import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import Slider from "@material-ui/core/Slider";
import Breadcrumb from '../../Common/Breadcrumb/Breadcrumb';
import { SvgIcon } from '@material-ui/core';
import ArrowDropDownIcon from "../../../icons/arrow-drop-down.svg"
import './HeaderStepper.scss';
import BasicDetails from '../../InsuranceTools/BasicDetails';
import Button from '@material-ui/core/Button';
import PrintNeedsAnalysis from '../../InsuranceTools/NeedsAnalysis/PrintNeedsAnalysis';

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor:'#ebf4f9'
    },
    headerColor: {
        color: theme.palette.primary.main,
        fontSize: '12px',
        fontWeight: '600'
    },
    slider: {
        color: `${theme.palette.primary.main} !important`,
    }
}));

function HeaderProgressTracker(props) {
    const classes = useStyles();
    var title = props.title || "Let's get the best quote for you";
    var headerProductsText = props.headerProductsText || '';
    var breadcrumbLinks = [{ name: 'HOME', href: '/' }];
    if (props.breadcrumbLink) {
        props.breadcrumbLink.map((index)=>{
            breadcrumbLinks.push(index)
        })
    }
    return (
        <div className={`header-stepper ${props.whiteBg ? 'white-background' : ''}`}>
            <Container fluid className={` common-background head fixed-top open-nav   ${classes.header} ${props.hidden ? 'd-none' : ''} ${!props.hideProgressTracker ? 'extend-headerTracker' : ''}`} >
                <Container fluid={props.currentPage ? true : false} className={props.hideProgressTracker ? 'h-100' : ''}>
                    <Row >
                        <div id="header-products-text" className={`${classes.headerColor} pt-4 mb-2`}>{headerProductsText}</div>
                    </Row>
                    {
                        props.currentPage ?
                            <Row>
                                <React.Fragment>
                                    <div id='breadcrumb-links' className="mb-2 pl-2">
                                        <Breadcrumb breadcrumbLinks={breadcrumbLinks} currentPage={props.breadCrumb} />
                                    </div>
                                </React.Fragment>
                            </Row>
                            :
                            null
                    }
                    <Row className={props.hideProgressTracker ? 'h-100' : ''}>
                        <Col className={props.headerProductsText ? 'pl-0 pr-0 pt-2 mb-1' : 'd-flex align-items-center h1-wrapper'}>
                            <h3 id="product-title" className="float-left px-2">{title}</h3>
                            {
                                props.showBasicDetails &&
                                <React.Fragment>
                                    <Button variant="contained" size="medium" className='float-right mr-2 start-over-btn' color="primary" onClick={props.onStartOver}>
                                        START OVER
                                    </Button>
                                    <PrintNeedsAnalysis />
                                </React.Fragment>
                            }
                        </Col>
                    </Row>

                    {!props.hideProgressTracker &&
                        <ProgressTracker {...props} />
                    }
                    {
                        props.showBasicDetails &&
                        <Row className='quoter-header px-2'>
                            <BasicDetails
                                fullFormState={props.fullFormState}
                                isQuoterPage={true}
                            />
                        </Row>
                    }

                </Container>
            </Container>

            <Container fluid={props.currentPage ? true : false} className={`page-content px-0 ${props.hidePadding ? '' : 'pt-5'} ${props.hidden ? '' : props.showBasicDetails ? 'page-content-quoter' : props.hideHeader ? 'header-hide-padding' : 'page-content-padding'} ${props.showContainer ? 'request-illustration-products' : ''}`}>
                {props.children}
            </Container>
        </div>
    );
}

function ProgressTracker(props) {

    let percentCompleted = ((props.step - .5) / props.totalSteps) * 100;

    if (props.lastStep) {
        percentCompleted = 100;
    }

    if (props.percent) {
        percentCompleted = props.percent;
    }

    const classes = useStyles();

    return (
        <Row className="headerProgressTrackerRow px-2">
            <Col className="pl-0 pr-0 stepperDiv">
                <div id="headerProgressTracker" className="headerProgressTracker pb-0 shadow-sm bg-white rounded">
                    <h2 id="step-name" className="headerProgressTrackerTitle">{props.stepName}</h2>
                    <p id="header-progress-steps" className="headerProgressSteps">
                        <b>Step {props.step} of {props.totalSteps} {props.displayStepTitleWithArrow ? <SvgIcon id="arrow-dropdown-icon" component={ArrowDropDownIcon} /> : ''}</b>
                    </p>
                    <Slider
                        value={percentCompleted}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="off"
                        step={100 / props.totalSteps}
                        marks
                        min={0}
                        max={100}
                        className={`slider-progress ${classes.slider}`}
                        disabled
                    />
                </div>
            </Col>
        </Row>
    )
}

export { HeaderProgressTracker }

HeaderProgressTracker.propTypes = {
    hideProgressTracker: PropTypes.bool,
    hidden: PropTypes.bool,
    title: PropTypes.string,
    whiteBg: PropTypes.bool,
    lastStep: PropTypes.bool,
}

ProgressTracker.propTypes = {
    stepName: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Common/HeaderStepper/HeaderProgressTracker.js